import Grid from "@mui/material/Grid"

import { getGreetingText } from "../../../utils/greetingConstants";
import { TextMidMedium, TextSmallBold } from "../../typography"
import styles from './HomepageHeaderGreeting.module.css';

const HomepageHeaderGreeting = () => {
  const greetingText = getGreetingText();
  return (
    <Grid className={styles.headerGreetingSection}>
      <TextMidMedium color="#3A3A3A" text={greetingText} />
      <TextSmallBold color="#3A3A3A" text="What are you cooking today?" />
    </Grid>
  )
}

export default HomepageHeaderGreeting;